import { useSelector } from "react-redux";
import { clickBookButtonGA } from "../../analytics";
import { IS_UAT_ENV } from "../../const";
import { getConfigSelector } from "../../Redux/appStateSlice";
import { bookNowTealium } from "../../TealiumEvents";
import { isBookingOpen } from "../../utils";

export const BookNowButton = ({ className, parent }) => {
  const config = useSelector(getConfigSelector);
  const bookingOpen = isBookingOpen(config);

  const handleAnalytics = () => {
    clickBookButtonGA(parent);
    bookNowTealium();
  };

  // Always show on UAT or if bookingOpen is true
  const showComponent = IS_UAT_ENV || bookingOpen;
  if (!showComponent) return null;

  return (
    <a
      href="https://www.ukholidaysinthesun.co.uk/"
      target="_blank"
      rel="noopener noreferrer"
      className={`btn btn-primary ${className}`}
      onClick={handleAnalytics}
      data-testid="book-now-button"
    >
      Book Now
    </a>
  );
};
